import React from "react";

const UserContext = React.createContext({
  user: null,
  jwtToken: null,
  userReady: false,
  loggedIn: false,
  selectedOrganization: null,
  selectedGestionCustomer: null,
  gestionCustomers: [],
  gestionCustomersLoaded: false,
  changeUser: () => {},
  setSelectedOrganization: () => {},
  setSelectedGestionCustomer: () => {},
  setGestionCustomers: () => {},
});

export default UserContext;
